/**
 * The path segment that prefixes modal routes in the URL.
 */
export const UMB_MODAL_ROUTE_PATH_SEGMENT = 'modal';
